define('services/external-video',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
], function(
    // Libs
    _, Backbone, Mustache, U
) {

    var ExternalVideo = Backbone.Model.extend({

        getLocation: function(href) {
            var link = document.createElement("a");
            link.href = href;
            return link;
        },

        /**
         * Get the direct watch URL for the video
         */
        getWatchUrl: function() {
            var videoId = this.getVideoId();

            switch (this.getProvider()) {
                case 'youtube':
                    return 'https://www.youtube.com/watch?v=' + videoId;
                case 'vimeo':
                    return 'https://vimeo.com/' + videoId;
                default:
                    return this.get('url');
            }
        },

        /**
         * Check if running in a native Capacitor app
         */
        isNativeApp: function() {
            var isNative = window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform();
            console.log('[ExternalVideo] isNativeApp:', isNative);
            return isNative;
        },

        /**
         * Open video in InAppBrowser modal WebView (for native apps)
         * This bypasses CSP frame-ancestors issues by using a separate browser context
         */
        openInAppBrowser: function() {
            var url = this.getWatchUrl();
            console.log('[ExternalVideo] openInAppBrowser called with URL:', url);
            console.log('[ExternalVideo] Capacitor available:', !!window.Capacitor);
            console.log('[ExternalVideo] Capacitor.Plugins:', window.Capacitor && window.Capacitor.Plugins);
            console.log('[ExternalVideo] InAppBrowser plugin:', window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.InAppBrowser);

            if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.InAppBrowser) {
                console.log('[ExternalVideo] Using InAppBrowser.openInWebView');
                // Parameters should be flat, not nested under 'options'
                window.Capacitor.Plugins.InAppBrowser.openInWebView({
                    url: url,
                    showURL: false,
                    showToolbar: true,
                    clearCache: false,
                    clearSessionCache: false,
                    mediaPlaybackRequiresUserAction: false,
                    closeButtonText: 'Done',
                    toolbarPosition: 'TOP',
                    showNavigationButtons: false,
                    android: {
                        allowZoom: false,
                        hardwareBack: true
                    },
                    iOS: {
                        allowInLineMediaPlayback: true,
                        enableViewportScale: true,
                        viewStyle: 'PAGE_SHEET',
                        animationEffect: 'COVER_VERTICAL'
                    }
                }).then(function() {
                    console.log('[ExternalVideo] InAppBrowser opened successfully');
                }).catch(function(err) {
                    console.error('[ExternalVideo] InAppBrowser failed:', err);
                    // Fallback to system browser
                    if (window.Capacitor.Plugins.Browser) {
                        console.log('[ExternalVideo] Falling back to Browser plugin');
                        window.Capacitor.Plugins.Browser.open({ url: url });
                    } else {
                        console.log('[ExternalVideo] Falling back to window.open');
                        window.open(url, '_blank');
                    }
                });
            } else {
                console.log('[ExternalVideo] InAppBrowser not available, using window.open');
                // Fallback for web
                window.open(url, '_blank');
            }
        },

        /**
         * Get embed URL for iframe embedding (web only)
         * For native apps, use openInAppBrowser() instead
         */
        getEmbedUrl: function() {
            var videoId = this.getVideoId(),
                params = "?autoplay=1&loop=1";

            switch (this.getProvider()) {
                case 'youtube':
                    // Direct YouTube embed works in web browsers
                    // Native apps should use openInAppBrowser() instead
                    return 'https://www.youtube.com/embed/' + videoId + params;
                case 'vimeo':
                    return 'https://player.vimeo.com/video/' + videoId + params;
            }
        },

        setVideoId: function() {
            var results,
                url = this.get('url');

            switch (this.getProvider()) {
                case 'youtube':
                    // Check for /shorts/ URL pattern first
                    results = url.match("youtube\.com/shorts/([^&#?]*)");
                    if (!results) results = url.match("[\\?&]v=([^&#]*)");
                    if (!results) results = url.match("youtu\..*\/([^&#]*)");
                    if (results) this.set('videoId', results[1]);
                    break;
                case 'vimeo':
                    results = url.match("(https?://)?(www.)?(player.)?vimeo.com/([a-z]*/)*([0-9]{6,11})[?]?.*");
                    if (results) this.set('videoId', results[5]);
                    break;
            }

            this.setThumbnailUrl();
        },

        getProvider: function() {
            return this.get('provider');
        },

        getVideoId: function() {
            return this.get('videoId');
        },

        setThumbnailUrl: function() {
            var videoId = this.getVideoId();

            switch (this.getProvider()) {
                case 'youtube':
                    return this.set('thumbnailUrl', "https://img.youtube.com/vi/" + videoId + "/hqdefault.jpg");
                case 'vimeo':
                    return Backbone.$.ajax({
                        url: 'https://www.vimeo.com/api/v2/video/' + videoId + '.json',
                        context: this,
                        dataType: 'jsonp',
                        success: function(data) {
                            this.set('thumbnailUrl', data[0].thumbnail_large);
                        }
                    });
            }
        },

        setProviderFromUrl: function(url) {
            if (!url) return;
            var provider;

            if (url.indexOf('youtu') !== -1) {
                provider = 'youtube';
            } else if (url.indexOf('vimeo') !== -1) {
                provider = 'vimeo';
            }

            return this.set({ provider: provider, url: url });
        }
    });

    return new ExternalVideo();

});

